export const state = {
	languagesData: {
		isLoading: false,
		isError: false,
		error: '',
		data: [],
	},
	currentLanguage: {
		label: 'English',
		code: 'en',
		direction: 'ltr',
	},
}

export default state
